import {PageSAP} from "../../shared-components/common/utils/menu/pagesEBU"

/**
 * The pages of the application.
 */
export const Page = {
    ...PageSAP,
}
